import { PersonVm } from "./PersonVm";
import { StatusVm } from "./StatusVm";
import { WorkshopVm } from "./WorkshopVm";

export class WorkshopCardVm{
    Id: number = 0;
    CardDataId:number = 0;
    CardNumber: string = "";
    Cvr: string = "";
    AuthorizationNumber: string = "";
    Person: PersonVm = new PersonVm();
    Workshop: WorkshopVm = new WorkshopVm();
    ValidFrom: Date | null = null;
    ValidTo: Date  | null = null;
    Status: StatusVm = new StatusVm()
}